import { VideoCard } from '@/modules/homepage/VideoCard/VideoCard';
import type { VideoInterface } from '@/types/homepage.types';

export const RenderVideo = ({ title, featuredImageURL, videoURL }: VideoInterface) => {
  return <VideoCard image={featuredImageURL} title={title} videoURL={videoURL} />;
};
